import { render } from "./RqOrderDetailsCard.vue?vue&type=template&id=613c70bb"
import script from "./RqOrderDetailsCard.vue?vue&type=script&lang=js"
export * from "./RqOrderDetailsCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__